var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMausoleumMarker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0087CF",
    stroke: "#F7F7F7",
    strokeLinejoin: "round",
    d: "M1.318 7.273c0 .602.378 1.116.91 1.318v4.637a1.41 1.41 0 0 0-.91 1.318v.818a1.5 1.5 0 0 0 1.5 1.5h5.164l1.674 1.59a.5.5 0 0 0 .689 0l1.673-1.59h5.164a1.5 1.5 0 0 0 1.5-1.5v-.819a1.41 1.41 0 0 0-.91-1.317V8.59a1.41 1.41 0 0 0 .91-1.318v-.818a1.5 1.5 0 0 0-1.5-1.5h-.658l-5.07-3.622a2.5 2.5 0 0 0-2.907 0l-5.07 3.622h-.659a1.5 1.5 0 0 0-1.5 1.5v.818Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7F7",
    d: "M13.097 12.727H11.69v-3.55l-1.383 3.55h-.622l-1.374-3.55v3.55H6.903V7.27H8.86l1.137 2.962 1.146-2.962h1.955v5.457Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMausoleumMarker);
export default __webpack_public_path__ + "static/media/mausoleum-marker.46e9ea6ff92a0ccb859f147fa8ecb8cc.svg";
export { ForwardRef as ReactComponent };